/* tslint:disable:no-inferrable-types no-trailing-whitespace import-spacing typedef-whitespace align */

import { WindowType       } from './window';
import { DocumentMetadata } from './document.metadata';
import { Train }            from '@/models/scenario/train';
import { DecisionPoint }    from '@/models/scenario/decision.point';

/**
 *
 * @class UserLogViewerMetadata
 *
 * @brief meta data for user log panel.  There should only be
 * one of these at a time
 *
 * - - - - - - - - - - - - - - - - - - -
 * @author    Michael Garvin (mike.garvin@ironroad.ca)
 * @date      April 2021
 *
 */
export class UserLogViewerMetadata extends DocumentMetadata {

  /** the database where the user log entries are stored */
  public dsn:  string = '';

  /** the user log entries tree to use */
  public collection: string = '';

  /** the tag for which input scenario this came from */

  public inputTag: string   = '';

  /** the train to focus on */
  public train: Train       = null;

  /** the decision point to focus at */
  public dp: DecisionPoint   = null;

  /** standard constructor */
  constructor(
    id:          string        = '',
    title:       string        = '',
    dsn:         string        = '',
    collection:  string        = '',
    inputTag:    string        = '',
    train:       Train         = null,
    dp:          DecisionPoint = null,
    icon:        string        = '<i class="fas fa-sitemap"></i>',
    type:        WindowType    = WindowType.UserLogViewer,
  ) {

    super(id, title, icon, type);

    this.dsn        = dsn;
    this.collection = collection;
    this.train      = train;
    this.dp         = dp;
    this.inputTag   = inputTag;
  }

  /** convert this element to a simplified form that can be easily serialized */
  public node(init?: any) {

    return super.node({input: this.dsn, collection: this.collection, train: this.train, dp: this.dp});
  }

  /** initialize this element given the data in the simplified node object */
  public fromNode(node: any) {

    super.fromNode(node);

    this.dsn        = node.dsn;
    this.collection = node.collection;
    this.train      = node.train;
    this.dp         = node.dp;
  }
}
